import React from "react";

export default function Compare() {
  const badHtml =
`<span class="dim">$</span> <span class="prompt">terraform plan</span>
Plan: 14 to add, 2 to change, 0 to destroy.

<span class="dim">$</span> <span class="prompt">infracost breakdown</span>
Monthly cost: <span class="warn">$412.30</span>

<span class="dim"># ping the platform team for policy review…</span>
<span class="err">ERROR</span>  tag policy: missing <span class="warn">owner</span>
<span class="dim"># fix, re-run, re-push…</span>
<span class="err">ERROR</span>  data-transfer cost missed: <span class="warn">+$88/mo</span>`;

  const goodHtml =
`<span class="dim">#</span> Drop a Lambda on the canvas

  <span class="ok">✓</span> synced to <span class="prompt">resources.tf</span>
  <span class="ok">✓</span> tags.owner inherited from branch
  <span class="ok">✓</span> 5/5 policies pass
  <span class="warn">ℹ</span> projected impact: <b>+$1.12/mo</b>
  <span class="warn">ℹ</span> implied data-transfer: <b>+$0.30/mo</b>

<span class="dim">#</span> Open PR — plan preview attached — merge`;

  return (
    <section id="problem">
      <div className="wrap">
        <div className="section-head reveal">
          <span className="eyebrow">Why this, why now</span>
          <h2 className="h2">Cloud changes shouldn't be a leap of faith.</h2>
          <p className="lead">
            Terraform shows the diff. Infracost guesses the bill. Your policy engine says no, eventually. InfraBlaze folds all three into one canvas — so the full picture lands before the PR, not after.
          </p>
        </div>
        <div className="compare reveal">
          <div className="compare-card is-bad">
            <span className="compare-label">Today</span>
            <h3 className="compare-title">Plan. Guess. Hope.</h3>
            <div className="term" dangerouslySetInnerHTML={{ __html: badHtml }} />
            <div className="body">Three tools, two chat threads, one surprise bill at month-end.</div>
          </div>
          <div className="compare-vs">
            <div className="compare-vs-line"></div>
            <span>vs</span>
            <div className="compare-vs-line"></div>
          </div>
          <div className="compare-card is-good">
            <span className="compare-label">With InfraBlaze</span>
            <h3 className="compare-title">See the whole change — before the PR.</h3>
            <div className="term" dangerouslySetInnerHTML={{ __html: goodHtml }} />
            <div className="body">Every cost, every policy check, on the same screen you're designing on.</div>
          </div>
        </div>
      </div>
    </section>
  );
}
